import { useState, useEffect } from 'react';
import { toast } from 'react-hot-toast';
import AdminPanel from './AdminPanel';
import LoginForm from './admin/LoginForm';
import authService from '../services/auth';

// Initialize auth service
authService.init();

const AdminAuth = () => {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [loading, setLoading] = useState(true);
  const [loginLoading, setLoginLoading] = useState(false);
  const [loginForm, setLoginForm] = useState({
    email: '',
    password: '',
  });

  // Check authentication status on component mount
  useEffect(() => {
    const checkAuth = () => {
      const authenticated = authService.isAuthenticated();
      setIsAuthenticated(authenticated);
      setLoading(false);
    };

    checkAuth();
  }, []);

  const handleLogin = async (e) => {
    e.preventDefault();
    setLoginLoading(true);

    try {
      const response = await authService.login(loginForm);
      console.log(response)

      // Ensure API service has the token
      if (response.token) {
        const apiService = (await import('../services/api')).default;
        apiService.setToken(response.token);
      }

      setIsAuthenticated(true);
      toast.success(`Welcome back!`);
      setLoginForm({ email: '', password: '' });
    } catch (error) {
      toast.error(error.message || 'Login failed');
    } finally {
      setLoginLoading(false);
    }
  };

  // Show loading spinner while checking authentication
  if (loading) {
    return (
      <div
        style={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          height: '100vh',
          fontSize: '18px',
        }}
      >
        Loading...
      </div>
    );
  }

  // Show login form if not authenticated
  if (!isAuthenticated) {
    return (
      <div>
        <LoginForm
          loginForm={loginForm}
          setLoginForm={setLoginForm}
          handleLogin={handleLogin}
          loading={loginLoading}
        />
      </div>
    );
  }

  // Show admin panel if authenticated
  return <AdminPanel />;
};

export default AdminAuth;
